import config from '@/config';

const convertPathname = (pathname: string) => {
  return {
    pathname: config.pathName + `${pathname ? '/' + pathname : ''}`,
    search: '?' + config.urlParamsValue,
  };
};

export const PATH = {
  DEFAULT: convertPathname(''),
  HOME: convertPathname('home'),
  ORDERS: convertPathname('orders'),
  DISPUTE: convertPathname('dispute'),
  SETTINGS: convertPathname('settings'),
  AFFILIATE: convertPathname('affiliate'),
  WHATNEW: convertPathname('whatnew'),
  WELCOME: convertPathname('welcome'),
  HANDLE_REQUEST: convertPathname('handle_request'),
};
